import axios from 'axios';

import {configHeaders} from '../utils/configHeaders';

export const getServices = async () => {
  try {
    const {data} = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/services`,
      await configHeaders()
    );

    return data;
  } catch (error) {
    return {error: error.response.data};
  }
};
